import type { ConcreteIndicator } from '@thinkalpha/platform-ws-client/contracts/dictionary.js';

/**
 * Builds the call text for inserting an indicator with its parameters' default values pre-filled.
 *
 * - Params with a `defaultValue.formula` use that formula verbatim.
 * - Params without a default render as empty slots, preserving structural arity so the InputHelper
 *   surfaces them to the user.
 * - Trailing empty slots are trimmed (`sma(20)` rather than `sma(20, , )`).
 */
export function buildIndicatorCallWithDefaults(indicator: ConcreteIndicator): { text: string } {
    const args = indicator.params.map((param) => param.defaultValue?.formula ?? '');

    while (args.length > 0 && args[args.length - 1] === '') {
        args.pop();
    }

    return { text: `${indicator.symbol}(${args.join(', ')})` };
}
